import { NgModule, ErrorHandler, inject, provideAppInitializer } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { AppConfigService } from 'src/app/app-config.service';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GlobalErrorHandler } from './core/interceptors/global.errorHandler';
import { AuthInterceptor } from './core/interceptors/http.interceptor';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ErrorService } from './shared/error/services/error.service';
import { ToastContainerComponent } from './shared/toast/toast-container/toast-container.component';
import { PlatformBootstrapService } from './modules/bootstrap/services/platform-bootstrap.service';
import { PlatformDegradedBannerComponent } from './modules/bootstrap/components/platform-degraded-banner/platform-degraded-banner.component';

export function setupAppConfigServiceFactory(service: AppConfigService): Function {
  return () => service.load().toPromise();
}

export function setupPlatformBootstrapFactory(service: PlatformBootstrapService): Function {
  return () => service.loadStatus().toPromise();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    ToastContainerComponent,
    PlatformDegradedBannerComponent,
    CoreModule,
    AppRoutingModule,
    BrowserModule,
    BrowserAnimationsModule,
  ],
  providers: [
    provideAppInitializer(() => {
      const initializerFn = setupAppConfigServiceFactory(inject(AppConfigService));
      return initializerFn();
    }),
    provideAppInitializer(() => {
      const initializerFn = setupPlatformBootstrapFactory(inject(PlatformBootstrapService));
      return initializerFn();
    }),
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    ErrorService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
